
/**
 * BoCapital — App Entry Point
 */

// ── Tab icon (set programmatically so it works regardless of HTML template) ──
(function setFavicon(href: string) {
  const existing = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
  const link: HTMLLinkElement = existing || document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/png';
  link.href = href;
  if (!existing) document.head.appendChild(link);

  const touch = document.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]');
  const appleLink: HTMLLinkElement = touch || document.createElement('link');
  appleLink.rel = 'apple-touch-icon';
  appleLink.href = href;
  if (!touch) document.head.appendChild(appleLink);
})('/assets/round.png');

// ── Pause CSS animations while the tab is hidden ─────────────────────────────
// A backgrounded tab has no reason to keep running the dashboard's infinite
// animations. This flag (consumed by the animation-gating rules in global.css)
// stops them from burning CPU/GPU and adding to thermal load during the long
// sessions where users reported the UI getting progressively laggier. Lives
// outside React so a re-render can never tear it down.
(function trackDocumentVisibility() {
  const apply = () => {
    document.documentElement.dataset.docHidden = document.hidden ? 'true' : 'false';
  };
  apply();
  document.addEventListener('visibilitychange', apply);
})();

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { installGlobalClientDiagnostics } from './services/clientDiagnostics';
import { installPerfSampler } from './services/perfSampler';
import './design-tokens/theme.css';
import './styles/global.css';
import './styles/utilities.css';

installGlobalClientDiagnostics();
// Background perf-trend sampler (all sessions, ~zero cost) + opt-in ?perf=1
// overlay. Was written but never wired into boot, so the overlay never showed
// and the perf_trend_regression telemetry never emitted.
installPerfSampler();

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
  );
}
